import { render } from "./admin_info.vue?vue&type=template&id=67449e1a"
import script from "./admin_info.vue?vue&type=script&lang=js"
export * from "./admin_info.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__